import { Flex } from '@mantine/core';
import type { TFunction } from 'i18next';
import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { GeoSetTargetable } from '@feathr/blackbox';
import { Button, type IColumn, Pill, TableColumnHeader } from '@feathr/components';
import { cssVar } from '@feathr/hooks';

import GeoFiltersOptions from '../GeoFiltersOptions';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

function TargetablesColumns(
  t: TFunction,
  onEdit: (targetable: GeoSetTargetable) => void,
  onSetDefault: (targetable: GeoSetTargetable) => void,
  defaultGeoSetId?: string,
  campaignCountsByGeoSetId?: Map<string, number>,
): Array<IColumn<GeoSetTargetable>> {
  return [
    {
      Header: TableColumnHeader({
        title: t('Geofilter set'),
        sortType: 'alpha',
      }),
      id: 'name',
      headerClassName: tableStyles.cellLeft,
      sortable: true,
      Cell({ original }): JSX.Element {
        const isDefault = original.isDefault(defaultGeoSetId);
        return (
          <Observer>
            {(): JSX.Element => (
              <Flex align={'center'} gap={cssVar('--spacing-2')}>
                <Button onClick={(): void => onEdit(original)} type={'link'}>
                  {original.get('name')}
                </Button>
                {isDefault && <Pill theme={'neutral'}>{t('Default')}</Pill>}
              </Flex>
            )}
          </Observer>
        );
      },
    },
    {
      Header: TableColumnHeader({
        title: t('Campaigns'),
      }),
      id: 'campaigns',
      width: 150,
      sortable: false,
      Cell({ original }): JSX.Element {
        const campaignCount = campaignCountsByGeoSetId?.get(original.id) ?? 0;
        return <span>{campaignCount}</span>;
      },
    },
    {
      Header: TableColumnHeader({
        title: t('Options'),
      }),
      id: 'options',
      width: 100,
      sortable: false,
      Cell({ original }): JSX.Element {
        return (
          <div className={tableStyles.cellCenter}>
            <Observer>
              {(): JSX.Element => (
                <GeoFiltersOptions
                  onEdit={onEdit}
                  onSetDefault={onSetDefault}
                  targetable={original}
                />
              )}
            </Observer>
          </div>
        );
      },
    },
  ];
}

export default TargetablesColumns;
